export {validateModel} from "./validate-model";
export const bugReport = "https://issues.amazon.com/issues/create?template=6adfb1b7-510a-4d4a-8b79-f0f836bc6266";
export const featureRequest = "https://issues.amazon.com/issues/create?template=6adfb1b7-510a-4d4a-8b79-f0f836bc6266";
export const productWiki = "https://w.amazon.com/bin/view/FCBookMarks";
export const shoutoutsLink = "https://atoz.amazon.work/shout-outs/send?alias=longzhiw";